import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { NGXLogger } from 'ngx-logger';
import { map, of } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';

import { memberRewardPickupListRequest, memberRewardPickupListResponse } from './member-reward-pickup.actions';
import { MemberRewardPickupService } from '../../services/member-reward-pickup.service';

@Injectable()
export class MemberRewardPickupEffects {
  constructor(
    private actions$: Actions,
    private logger: NGXLogger,
    private memberRewardPickupService: MemberRewardPickupService
  ) {}

  memberRewardPickupRequest$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(memberRewardPickupListRequest),
      tap((action) => this.logger.debug(`@Effect Member Reward Pickup Request ${JSON.stringify(action.payload)}`)),
      switchMap(({ payload }) => {
        return this.memberRewardPickupService.searchMemberRewardPickupList(payload).pipe(
          map((response) => {
            return memberRewardPickupListResponse({
              response
            });
          }),
          catchError((err) => of(err))
        );
      })
    );
  });
}
